import React, { useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Creators as ProductCreators } from 'store/products/products-duck.js';
import ProductPreview from 'components/product-preview';
import { Box, Typography } from '@mui/material';

const HighLightedSession = ({ highlightedProducts, productsFetchHighlightedAsync }) => {
  const fetch = useCallback(() => {
    productsFetchHighlightedAsync();
  }, [productsFetchHighlightedAsync]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  const productGroups = Array.isArray(highlightedProducts)
    ? [{ subcategory: '', products: highlightedProducts }]
    : Object.entries(highlightedProducts || {}).map(([subcategory, products]) => ({
        subcategory,
        products: Array.isArray(products) ? products : [],
      }));

  if (productGroups.every(({ products }) => products.length === 0)) return null;

  return (
    <Box sx={{ mt: 4 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        {productGroups.map(({ subcategory, products }) =>
          products.length > 0 ? (
            <Box key={subcategory || 'highlighted-products'}>
              {subcategory && (
                <Typography
                  variant="h5"
                  sx={{
                    color: '#92b21f',
                    fontWeight: 'bold',
                    textTransform: 'uppercase',
                    mb: 2,
                    textShadow: '0 0 8px rgba(146, 178, 31, 0.6)',
                  }}
                >
                  {subcategory}
                </Typography>
              )}

              <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: { xs: 1.5, sm: 2 },
                  py: 1,
                }}
              >
                {products.map((item) => (
                  <ProductPreview product={item} key={item.id} />
                ))}
              </Box>
            </Box>
          ) : null,
        )}
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  highlightedProducts: state.Product.highlightedProducts,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(ProductCreators, dispatch);

HighLightedSession.propTypes = {
  highlightedProducts: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.objectOf(
      PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired,
          price: PropTypes.string.isRequired,
          promotionalPrice: PropTypes.string,
          highlightedTag: PropTypes.string,
          mainImage: PropTypes.string.isRequired,
        }),
      ),
    ),
  ]).isRequired,
  productsFetchHighlightedAsync: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(HighLightedSession);
